import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useRouter } from 'next/router'
import { Col, Container, Row } from 'react-bootstrap'
import dynamic from 'next/dynamic'

import { seriesCategoryNav } from '../../constants/allNavBars'
import Layout from '../layout'
import { navLoader, pageHeaderLoader, scoreCardSliderLoader } from '@shared/libs/allLoader'
import { WIDGET } from '@shared/constants'
import useWindowSize from '@shared/hooks/windowSize'
// import getCategoryMeta from '@shared/libs/meta-details/category'
// import { allRoutes } from '@shared/constants/allRoutes'
import { ENUM_SEO_SUBTYPE, ENUM_SERIES_CATEGORY_PAGES, ENUM_STATS_PAGE } from '@shared/enum'
import { arraySortByOrder } from '@shared/utils'

const PageHeader = dynamic(() => import('@shared-components/pageHeader'), { loading: () => pageHeaderLoader() })
const CommonNav = dynamic(() => import('@shared-components/commonNav'), { loading: () => navLoader() })
const AllWidget = dynamic(() => import('@shared/components/allWidget'), { ssr: false })
const Ads = dynamic(() => import('@shared/components/ads'))
const ScorecardSlider = dynamic(() => import('@shared-components/scorecardSlider'), { loading: () => scoreCardSliderLoader() })
const ClientCommonNav = dynamic(() => import('@shared-components/commonNav/client'), { loading: () => navLoader() })
// const PromotionFull = dynamic(() => import('@shared/components/adsPromotion/promotionFull'))
const CommonContent = dynamic(() => import('@shared/components/commonContent'))
const OnMouseAndScroll = dynamic(() => import('@shared/components/lazyLoad/onMouseAndScroll'))
const SeriesPointTable = dynamic(() => import('@shared/components/widgets/seriesPointTable'))
const SeriesMatches = dynamic(() => import('@shared/components/widgets/seriesMatches'))
// const IplRetentions = dynamic(() => import('@shared/components/widgets/iplRetentions'))
// const SeriesKeyStats = dynamic(() => import('@shared/components/widgets/SeriesKeyStats'))

const CategoryContent = ({
  seoData,
  children,
  category,
  isFantasyArticle,
  showNav,
  tabSeo,
  subPages,
  tab,
  scoreCard,
  ssrNav,
  statsData
}) => {
  const router = useRouter()
  // const { t } = useTranslation('common')
  const [width] = useWindowSize()
  const [activeTab, setActiveTab] = useState(router?.query?.tab === 'videos' ? 'videos' : 'home')
  const isStatsPages = ENUM_SEO_SUBTYPE[seoData?.eSubType] === 'stats' || seoData?.eSubType === 's'
  // const isHomeActive = allRoutes.seriesHome(category?.oSeo?.sSlug) === router.asPath?.split('?')[0]
  // const isIpl = category?._id === '623184adf5d229bacb00ff63'
  // const tagLine = {
  //   fixtures: 'The below-mentioned fixtures are of IPL 2022. The fixtures for IPL 2023 will be added once announced',
  //   standings: 'The below-mentioned point table is from IPL 2022. The IPL 2023 standings will be added once the tournament starts',
  //   stats: 'The below-mentioned stats are from IPL 2022. The IPL 2023 numbers will be added once the league starts'
  // }
  function getNavItems() {
    const items = []
    ssrNav?.forEach((t) => {
      if (ENUM_SERIES_CATEGORY_PAGES[t?.eSubType]) {
        if (t?.eSubType === 'ac') {
          const isFuture = Date.now() > new Date(category?.oAuctionSeries?.dEndDate).getTime()
          items.push({
            navItem: isFuture ? ENUM_SERIES_CATEGORY_PAGES[t?.eSubType] : 'Retained',
            url: `/${t?.sSlug}/`,
            active: t?.eSubType === seoData?.eSubType
          })
        } else {
          items.push({
            navItem: ENUM_SERIES_CATEGORY_PAGES[t?.eSubType],
            url: `/${t?.sSlug}/`,
            active: t?.eSubType === seoData?.eSubType
          })
        }
      } else if (t?.eSubType === null) {
        // Home Tab
        items.push({
          navItem:
            category?.oSeo?.eType === 'au' ? category?.oAuctionSeries?.eAuctionStatus === 'l' ? 'Live' : 'Overview' : ENUM_SERIES_CATEGORY_PAGES.h,
          url: `/${t?.sSlug}/`,
          active: t?.eSubType === seoData?.eSubType
        })
      }
    })
    const order = [
      'live',
      'completed',
      'players',
      'home',
      'news',
      'videos',
      'fixtures',
      'points-table',
      'standings',
      'stats',
      'fantasy-tips',
      'teams',
      'squads',
      'archives',
      'live-blog'
    ]
    const auctionOrder = ['live', 'overview', 'completed', 'Retained', 'teams', 'live-blog', 'news']
    return arraySortByOrder({ data: items, order: category?.oSeo?.eType === 'au' ? auctionOrder : order, key: 'navItem' })
  }

  function getNav() {
    if (showNav) {
      if (
        category?.eType === 'gt' ||
        category?.eType === 'pct' ||
        category?.eType === 't' ||
        (category?.eType === 's' && category?.oSeo?.eType !== 'au') ||
        category?.eType === 'fac' ||
        category?.eType === 'p'
      ) {
        return (
          <ClientCommonNav
            items={seriesCategoryNav({
              isSeries: category?.eType,
              categoryId: category?._id
            })}
            active={activeTab}
            onTabChange={(e) => setActiveTab(e)}
            isSticky
          />
        )
      } else {
        return (
          <>
            <CommonNav items={getNavItems()} isSticky />
          </>
        )
      }
    }
  }

  const getTitleDesc = () => {
    let tabData = {}
    ssrNav?.forEach((cat) => {
      if (seoData?.eSubType === cat?.eSubType) {
        tabData = cat
      }
    })
    return tabData
  }

  function showDescription() {
    if (
      // ['63b677f06bd6d138cfcfab5c', '63b678036bd6d138cfcfb08d', '63b678096bd6d138cfcfb168']?.includes(seoData?._id)
      ['6396dd2588e3e61623afa20a', '630ca60ff22e6651888369d3', '6396dd2988e3e61623afa355']?.includes(seoData?._id)
      // seoData?._id === '6396dd2588e3e61623afa20a' || // Orange cap
      // seoData?._id === '630ca60ff22e6651888369d3' // ipl points table
      // seoData?._id === '6396dd2988e3e61623afa355' // purple cap
    ) {
      return true
    } else return false
  }

  // function
  // console.log(category)

  const getSubPagesDetail = getTitleDesc()
  return (
    <Layout
      data={{
        ...category,
        sTitle: category?.sName,
        oSeo: seoData
        // getCategoryMeta({ oSeo: { ...seoData, ...tabSeo }, oCategory: category, tab: tab, t, router })
      }}
      scoreCard={category?.eType === 'as' ? scoreCard : undefined}
    >
      {category?.eType === 'as' && scoreCard?.length > 0 && (
        <ScorecardSlider
          data={scoreCard}
          seriesId={category?.iSeriesId}
          // adData={{
          //   id: 'div-ad-gpt-138639789-1679039771-0s',
          //   adIdDesktop: 'Crictracker_OLD_Desktop_LiveScore_ATF2_320x140',
          //   adIdMobile: 'Crictracker_OLD_Mobile_LiveScore_ATF2_320x140',
          //   dimensionDesktop: [320, 140],
          //   dimensionMobile: [320, 140],
          //   mobile: true
          // }}
        />
      )}
      <main className="pb-3 pt-3">
        <Container>
          <Ads
            id="div-ad-category-ATF"
            adIdDesktop="Crictracker_New_Desktop_SP_ATF1_728x90"
            adIdMobile="Crictracker_New_Mobile_SP_TOP_320x50"
            dimensionDesktop={[728, 90]}
            dimensionMobile={[320, 50]}
            slotId="23148549803"
            hideOn={isStatsPages ? 'none' : 'mobile'}
            mobile={isStatsPages}
            className={'text-center mb-3'}
          />
          <Row>
            <Col xl={8} xxl={9} className="left-content">
              <PageHeader
                name={getSubPagesDetail?.sDTitle || category?.sName}
                favBtn={category?.eType === 'as' || category?.eType === 's'}
                desc={seoData?.eSubType ? getSubPagesDetail?.sContent : category?.sContent}
                type={category?.eType}
                // id={seoData?.iId}
                id={seoData?.eSubType === 'ati' ? seoData?.iSecondResourceId : seoData?.iId}
                isFavorite={category?.bIsFav}
                isFantasyArticle={isFantasyArticle}
                seoData={seoData}
                showReadMoreButton={ENUM_STATS_PAGE[seoData?.eSubType] === 'stats' ? statsData?.length !== 0 : true}
              />
              {/* {seoData?._id === '63d3dafbd3d8efade78ce20a' && (
                <>
                  <IplRetentions />
                </>
              )} */}
              {getNav()}
              {/* Only for desktop after nav */}
              {seoData?.eSubType !== 'ac' && seoData?.eSubType !== 'ati' && (
                <Ads
                  id="div-ad-gpt-108639789-Desktop"
                  adIdDesktop="Crictracker_New_Desktop_SP_MID1_728x90"
                  adIdMobile="Crictracker_New_Mobile_SP_MID_300x250"
                  dimensionDesktop={[728, 90]}
                  dimensionMobile={[300, 250]}
                  slotId="23148549803"
                  hideOn="mobile"
                  mobile
                  className="text-center mb-2 mb-md-4"
                />
              )}
              {/* {(isIpl) && <p className='text-uppercase' ><u><b>{tagLine[tab]}</b></u></p>} */}
              {children({ activeTab, changeTab: (e) => setActiveTab(e) })}
              {/* // Only for mobile after children */}
              {(width < 767 || showDescription() || ENUM_STATS_PAGE[seoData?.eSubType] === 'stats') && getSubPagesDetail?.sContent && (
                <Ads
                  id="div-ad-gpt-1138639789-mobile"
                  adIdDesktop="Crictracker_New_Desktop_SP_MID2_728x90"
                  adIdMobile="Crictracker_New_Mobile_SP_ATF_300x250"
                  slotId="23148549803"
                  dimensionDesktop={[728, 90]}
                  dimensionMobile={[300, 250]}
                  mobile
                  className="text-center mt-2"
                />
              )}
              {showDescription() && getSubPagesDetail?.sContent && (
                <>
                  <hr />
                  <section className="common-box">
                    <CommonContent isDark>
                      <div dangerouslySetInnerHTML={{ __html: getSubPagesDetail?.sContent }} />
                    </CommonContent>
                  </section>
                </>
              )}
            </Col>
            <Col xl={4} xxl={3} className="common-sidebar d-none d-lg-block">
              {/* {(seoData?._id === '623184b8f5d229bacb01027f' || seoData?._id === '623184aaf5d229bacb00fe6b') && (
                <SeriesKeyStats
                  iSeriesId="649ac0872979adc89b9606f0"
                  mostSixes={{ id: '6230302c358523ee1d2692ce', URL: '/cwc-cricket-world-cup/stats/batting-most-sixes/' }}
                  mostRuns={{ id: '62302fc0358523ee1d264d15', URL: '/cwc-cricket-world-cup/stats/batting-most-runs/' }}
                  // mostFifties={{ id: '62303026358523ee1d2690a7', URL: '/cwc-cricket-world-cup/stats/batting-most-run50/' }}
                  mostCenturies={{ id: '6230301e358523ee1d268da4', URL: '/cwc-cricket-world-cup/stats/batting-most-centuries/' }}
                  mostWickets={{ id: '6230303b358523ee1d269831', URL: '/cwc-cricket-world-cup/stats/bowling-top-wicket-takers/' }}
                  statsURL="/cwc-cricket-world-cup/stats/"
                  title="WC 23"
                  CapSectionTitle="Top Players"
                />
              )} */}
              {seoData?.eSubType !== 'f' && category?.eType === 'as' && (
                <SeriesMatches id={category?.iSeriesId} seriesStatus={category?.oSeries?.sStatus} />
              )}
              {seoData?.eSubType !== 's' && category?.eType === 'as' && category?.oSeries?.nTotalTeams > 2 && (
                <SeriesPointTable id={category?.iSeriesId} title={category?.oSeries?.sSrtTitle} pageUrl={subPages?.s?.sSlug} />
              )}
              {seoData?.eType !== 'au' && (
                <>
                  <AllWidget type={WIDGET.ranking} show />
                  <OnMouseAndScroll>
                    <AllWidget type={WIDGET.currentSeries} show />
                  </OnMouseAndScroll>
                </>
              )}
              {/* In the right side bar desktop/mobile */}
              <Ads
                id="div-ad-gpt-138639789-164660-Crictracker_Desktop_SP_RightATF_300"
                adIdDesktop="Crictracker_New_Desktop_SP_RightMID_300x600"
                slotId="23148549803"
                dimensionDesktop={[300, 600]}
                hideOn="mobile"
                className="text-center sticky-ads position-sticky mb-2"
              />
            </Col>
          </Row>
        </Container>
      </main>
    </Layout>
  )
}
CategoryContent.propTypes = {
  seoData: PropTypes.object,
  category: PropTypes.object,
  children: PropTypes.func,
  isFantasyArticle: PropTypes.bool,
  showNav: PropTypes.bool,
  tabSeo: PropTypes.object,
  subPages: PropTypes.object,
  scoreCard: PropTypes.array,
  tab: PropTypes.string,
  ssrNav: PropTypes.array,
  statsData: PropTypes.array
}

export default CategoryContent
